import { useQuery } from 'react-query';

import type { FreelancerCompetence } from 'state/remote/types';

export type FreelancerCompetencesResponse = {
  data: FreelancerCompetence[];
  isLoading?: boolean;
  error: Error | null;
};

const useGetFreelancerCompetences = (): FreelancerCompetencesResponse => {
  const getFreelancerDetails = async () => {
    const response = await fetch('/api/freelancer/competence-options');
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  };
  const { isLoading, error, data } = useQuery<FreelancerCompetence[], Error>(
    ['get-freelancer-competences'],
    getFreelancerDetails,
  );

  return { data: data ?? ({} as FreelancerCompetence[]), error, isLoading };
};

export default useGetFreelancerCompetences;
